var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/shareholder/conf'},
    {title:'股东管理',path:'/shop/plugin/shareholder/manage'},
    {title:'分红日志',path:'/shop/plugin/shareholder/log'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }